module.exports = {"prefix":"sa","logoEN":"logo-retina.png","logoAR":"logo-retina.png","logoWidth":"250px","mainImageEN":"sa_main.jpg","mainImageAR":"sa_main.jpg","baseColor":"#9eacc1","secondaryColor":"#45429a","themeColor":"#45429a","modules":{"statisticalTablesVisible":false,"keyIndustrialIndicatorsVisible":true,"directoryOfManufacturingVisible":true,"performanceMonitoringVisible":false,"publicationsVisible":false,"onlineSurveyVisible":false},"hasMenuDatabases":true,"hasFooterLinks":true,"hasSubfooterLinks":true,"md5Hash":"0f6cf575e09fd1dcd0fe69ff638f52dd"}


//////////////////
// WEBPACK FOOTER
// ./src/features/tenant/config/sa.json
// module id = 860
// module chunks = 4